import { createContext } from "react";
import type { SharedValue } from "@-/com.npmjs.react-native-reanimated";
export interface ToolbarSheetShadowFrame {
  height: number;
  width: number;
  x: number;
  y: number;
}
export type ToolbarSheetShadowSource = SharedValue<ToolbarSheetShadowFrame | null>;
export const ToolbarSheetShadowSourceContext = createContext<ToolbarSheetShadowSource | null>(null);
export const ToolbarSheetShadowPublisherContext = createContext<
  ((source: ToolbarSheetShadowSource) => () => void) | null
>(null);
/** Inactive retained routes must not paint over the current screen. */
export const ToolbarSheetShadowVisibleContext = createContext(true);

/** Target state alone misses interactive opening and the closing/cancel animation. */
export function isToolbarSheetShadowHidden(hidden: boolean, drawerProgress: number): boolean {
  "worklet";
  return hidden || drawerProgress > 0;
}
